import { appHandler } from '@blaze-cms/core-ui';
import { EVENT_PREFIX } from '../constants';

const emitCartEvent = (event, extraData = {}, client = null) => {
  const app = appHandler.getApp();
  if (!app) {
    // eslint-disable-next-line no-console
    console.error('Error emitting cart event: app is not defined');
    return;
  }

  const { eventName } = event;
  return app.events.emitAsync(`${EVENT_PREFIX}${eventName}`, { ...event, ...extraData, client });
};

export default emitCartEvent;
